import './Description.css';

import Button from 'components/Button/Button';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import Placeholder from 'react-placeholder';
import styled from 'styled-components';
import Section from 'wrappers/Section/Section';

interface IProps {
  loading: boolean;
  text?: string | false;
  className?: string;
  buttonText?: string;
  link: string | null;
}

type Props = IProps & IWithCountryProps & WithLanguageProps;

export const Description: React.SFC<Props> = props => (
  <Section className={props.className}>
    <Container>
      <ContentContainer>
        <ContentInner>
          <Placeholder type="text" rows={5} ready={!props.loading}>
            <Markdown
              className="description-markdown"
              source={props.getText(props.text)}
            />
            {props.buttonText && (
              <Button link={props.link || `/rules`}>{props.buttonText}</Button>
            )}
          </Placeholder>
        </ContentInner>
      </ContentContainer>
    </Container>
  </Section>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 60px 0;
  div {
    flex: 1;
  }
  @media (max-width: 1300px) {
    flex-direction: column;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 500px;
`;

const ContentInner = styled.div`
  max-width: 650px;
`;

export default withLanguageState(withCountry(Description));



// WEBPACK FOOTER //
// ./src/components/Description/Description.tsx